import { CalendarService } from '@b2b/common/services/calendar';
import { UserPreferencesService } from '@b2b/common/services/userPreferences/types';
import { TODO } from '@b2b/types/core/utils';
import uiRouter from '@uirouter/angularjs';
import angular, { IDocumentService, IScope } from 'angular';

interface CalendarEventModel {
  id: string;
  name: string;
  startTime: Date | string;
  endTime: Date | string;
}

CalendarEventDirective.$inject = [];
function CalendarEventDirective() {
  CalendarEventController.$inject = [
    '$scope',
    '$element',
    '$document',
    'ValidateService',
    'HelpersService',
    'UserPreferencesService',
    'CalendarService',
  ];

  function CalendarEventController(
    $scope: IScope & { calendarCreateEvent: TODO; calendarCreateEventId: TODO },
    $element: JQuery,
    $document: IDocumentService,
    ValidateService: TODO,
    HelpersService: TODO,
    UserPreferencesService: UserPreferencesService,
    calendarService: CalendarService,
  ) {
    const ctrl = {
      isEdit: false,
      isComplete: false,
      isSubmitted: false,
      isValidName: true,
      clicks: 0,
      displayStartTime: '',
      displayEventTime: '',
      displayTitle: 'New Event',
      displayEventName: '',
      displayScheduleName: '',
      displayPeople: '',
      displayPlaces: '',
      displayEquipment: '',
      dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),
      hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
      currentTarget: '',

      model: {
        id: '',
        name: '',
        startTime: '' as Date | string,
        endTime: '',
      } as CalendarEventModel,

      init: function () {
        $scope.$on('calendar::onDayClick', ctrl.onDayClick);
        $scope.$on('calendar::onEventClick', ctrl.onEventClick);
        console.log('calendarCreateEvent::init -> $document', $document);

        $document.on('click', ctrl.onDocumentClick);
        $document.on('keydown', ctrl.onDocumentKeydown);

        $scope.$on('$destroy', () => {
          ctrl.cancel();
          $document.unbind('click');
          $document.unbind('keydown');
        });
      },

      validNameCheck: function () {
        let result = true;

        if (ctrl.isSubmitted) {
          result = ValidateService.validate([{ len: { value: ctrl.model.name } }]);
        }

        console.log('calendarCreateEvent::isValidName', result);
        ctrl.isValidName = result;

        return result;
      },

      complete: function () {
        ctrl.isSubmitted = true;

        $element.removeClass('show');

        $scope.$emit('calendarCreateEvent::complete', {
          name: ctrl.model.name,
          startTime: ctrl.model.startTime,
          endTime: ctrl.model.endTime,
        });
      },

      edit: function () {
        // Event should be handled higher up the scope chain in calendar.js
        console.log('calendarCreateEvent::edit');
        $element.removeClass('show');
        $scope.$emit('calendarCreateEvent::edit', { model: ctrl.model });
        ctrl.isSubmitted = false;
        ctrl.isComplete = false;
      },

      view: function () {
        // Event should be handled higher up the scope chain in calendar.js
        console.log('calendarCreateEvent::view');
        $element.removeClass('show');
        $scope.$emit('calendarCreateEvent::view', { model: ctrl.model });
        ctrl.isSubmitted = false;
        ctrl.isComplete = false;
      },

      cancel: function () {
        // Event should be handled higher up the scope chain in calendar.js
        console.log('calendarCreateEvent::cancel');
        $element.removeClass('show');
        $scope.$emit('calendarCreateEvent::cancel');
        ctrl.isSubmitted = false;
        ctrl.isComplete = false;
        ctrl.clicks = 0;

        if (ctrl.currentTarget) {
          angular.element(ctrl.currentTarget).focus();
          ctrl.currentTarget = '';
        }
      },

      done: function () {
        if (ctrl.isEdit) {
          ctrl.view();
        } else {
          ctrl.complete();
        }
      },

      getRequestsForCategory: function (event, category) {
        const limit = 3;
        let fulfilled = 0;
        let total = 0;
        let r = '';
        let requests;

        const categorySuffix = category === 'place' ? 'Places' : HelpersService.cap(category);

        if (event.requestSummary && event.requestSummary.hasOwnProperty(category)) {
          fulfilled = event.requestSummary[category].fulfilledRequestsCount
            ? event.requestSummary[category].fulfilledRequestsCount
            : 0;
          total = event.requestSummary[category].totalRequestsCount
            ? event.requestSummary[category].totalRequestsCount
            : 0;
          requests = total ? fulfilled + '/' + total : '';
          // Show resource name if total and fulfilled is 1 and only 1
          if (fulfilled > 0) {
            if (
              event.requestSummary[category].resourceNames instanceof Array &&
              event.requestSummary[category].resourceNames[0]
            ) {
              if (total === fulfilled) {
                if (fulfilled > 3) {
                  r =
                    event.requestSummary[category].resourceNames.slice(0, limit).join(', ') +
                    ', +' +
                    (fulfilled - limit) +
                    ' more';
                } else {
                  r = event.requestSummary[category].resourceNames.join(', ');
                }
              } else if (fulfilled < total) {
                if (fulfilled > 3) {
                  r =
                    event.requestSummary[category].resourceNames.slice(0, limit).join(', ') +
                    ', +' +
                    (fulfilled - limit) +
                    ' more';
                } else {
                  r = event.requestSummary[category].resourceNames.join(',');
                }
                r += ', ' + (total - fulfilled) + ' unassigned';
              }

              r = categorySuffix + ': ' + r;
            }
          } else {
            r = requests ? requests + ' ' + categorySuffix : '';
          }
        }

        return r;
      },

      onDocumentClick: function (e, data) {
        const target = $(e.target);
        const id = 'calendar-create-event-' + $scope.calendarCreateEventId;

        ctrl.clicks++;
        console.log('calendarCreateEvent::onDocumentClick -> e', e);
        console.log('calendarCreateEvent::onDocumentClick -> target', id, target.attr('id'));
        console.log('calendarCreateEvent::onDocumentClick -> clicks', ctrl.clicks);

        if (target.attr('id') !== id && target.parents('#' + id).length === 0 && ctrl.clicks > 1) {
          ctrl.cancel();
        }

        if (e.target.innerHTML.toLowerCase() === 'today') {
          $scope.$emit('calendarCreateEvent::todayClick');
        }
      },

      onDocumentKeydown: function (e, data) {
        if (e.keyCode === 27) {
          ctrl.clicks = 0;
          ctrl.cancel();
        }
      },

      fromDate: function (date: Date): Date {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
      },

      formatEventTime: function (startTime: Date, endTime): string {
        return `${calendarService.toFormat(startTime, ctrl.hourFormat)} - ${calendarService.toFormat(endTime, ctrl.hourFormat)}`;
      },

      onEventClick: function (e, data) {
        const vWidth = $(window).width() ?? 0;
        const sTop = $(window).scrollTop() ?? 0;
        const elWidth = parseInt(String($element.width()), 10);

        const el = $(data.event.target);
        const position = el.offset() ?? { left: 0, top: 0 };

        const startTime = ctrl.fromDate(data.calEvent.start);
        const endTime = ctrl.fromDate(data.calEvent.end ? data.calEvent.end : data.calEvent.start);

        ctrl.displayStartTime = calendarService.toFormat(startTime, ctrl.dateFormat);
        ctrl.displayEventTime = ctrl.formatEventTime(startTime, endTime);
        ctrl.displayTitle = data.calEvent.title || 'New Event';
        ctrl.displayEventName = data.calEvent.eventName || 'New Event';
        ctrl.displayScheduleName = data.calEvent.scheduleName;
        ctrl.displayPeople = ctrl.getRequestsForCategory(data.calEvent, 'people');
        ctrl.displayPlaces = ctrl.getRequestsForCategory(data.calEvent, 'place');
        ctrl.displayEquipment = ctrl.getRequestsForCategory(data.calEvent, 'equipment');
        ctrl.isSubmitted = false;
        ctrl.isEdit = data.calEvent.title;
        ctrl.isComplete = false;
        ctrl.clicks = 0;
        ctrl.isValidName = true;
        ctrl.model.name = data.calEvent.title;
        ctrl.model.id = data.calEvent.id;
        ctrl.model.startTime = startTime;
        ctrl.model.endTime = endTime;
        ctrl.currentTarget = '#fc-event-id-' + data.calEvent.id;

        let top: string | number = position.top - parseInt(String($element.height()), 10) - 30;
        let left = position.left;

        if (parseInt(String(top), 10) < sTop) {
          top = (el.offset()?.top ?? 0) + 50;
          top = top + 'px';
        }

        if (left + elWidth > vWidth) {
          left = vWidth - elWidth;
        }

        $element.css({ top: top, left: left }).addClass('show');

        ctrl.setFocusElements();
      },

      setFocusElements: function () {
        const inputs = $element.find('a, select, input, textarea, button');
        const firstInput = inputs.first();
        const lastInput = inputs.last();

        firstInput.focus();

        /**
         * redirect first shift+tab to last input
         */
        firstInput.on('keydown', (e) => {
          if (e.which === 9 && e.shiftKey) {
            e.preventDefault();
            lastInput.focus();
          }
        });
        /**
         * redirect last tab to first input
         */
        lastInput.on('keydown', (e) => {
          if (e.which === 9 && !e.shiftKey) {
            e.preventDefault();
            firstInput.focus();
          }
        });
      },

      onDayClick: function (e, data) {
        const vWidth = $(window).width() ?? 0;
        const sTop = $(window).scrollTop() ?? 0;
        const elWidth = parseInt(String($element.width()), 10);

        console.log('calendarCreateEvent::onDayClick', data);

        const el = $(data.view.currentTarget);
        const position = el.offset() ?? { left: 0, top: 0 };

        const startTime = new Date(data.date.getFullYear(), data.date.getMonth(), data.date.getDate(), 12, 0);
        const endTime = new Date(data.date.getFullYear(), data.date.getMonth(), data.date.getDate(), 13, 30);

        ctrl.displayStartTime = calendarService.toFormat(startTime, ctrl.dateFormat);
        ctrl.displayEventTime = ctrl.formatEventTime(startTime, endTime);
        ctrl.displayTitle = 'New Event';
        ctrl.displayEventName = 'New Event';
        ctrl.displayScheduleName = '';
        ctrl.displayPeople = '';
        ctrl.displayPlaces = '';
        ctrl.displayEquipment = '';
        ctrl.isSubmitted = false;
        ctrl.isComplete = false;
        ctrl.isEdit = false;
        ctrl.clicks = 0;
        ctrl.isValidName = true;
        ctrl.model.name = '';
        ctrl.model.id = '';
        ctrl.model.startTime = startTime;
        ctrl.model.endTime = endTime;
        ctrl.currentTarget = data.view.currentTarget;

        $scope.$apply();

        let top = position.top - parseInt(String($element.height()), 10) + 'px';
        let left = position.left;

        if (parseInt(top, 10) < sTop) {
          top = (el.offset()?.top ?? 0) + 140 + 'px';
        }

        if (left + elWidth > vWidth) {
          left = vWidth - elWidth;
        }

        $element.css({ top, left }).addClass('show');
        angular.element('#input-calendar-create-event-name').focus();
      },
    };

    $scope.calendarCreateEvent = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/calendar/createEvent/createEvent.tpl.html',
    scope: {
      calendarCreateEventId: '@calendarcreateeventid',
    },

    link: function ($scope: IScope, $element: JQuery) {
      // Modified after controller runs
      $('body').append($element);
    },

    controller: CalendarEventController,
  };
}

export const CalendarEventDirectiveModule = angular
  .module('acme.common.directive.calendarCreateEvent', [
    uiRouter,
    'acme.common.service.validate',
    'acme.common.service.helpers',
    'acme.common.service.userPreferences',
    'acme.common.service.calendar',
  ])
  .directive('calendarCreateEvent', CalendarEventDirective).name;
